import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "./Modal";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Select from "react-select";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [clubId, setClubId] = useState(null);
  const [clubOptions, setClubOptions] = useState([]);
  const {
    classes,
    loading: classesLoading,
    error: classesError,
  } = useFetchClasses();
  const {
    sections,
    loading: sectionsLoading,
    error: sectionsError,
  } = useFetchSections(selectedClass);
  const [selectedClub, setSelectedClub] = useState("");
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [filteredStudentList, setFilteredStudentList] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [errorStudents, setErrorStudents] = useState(null);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [selectedClubs, setSelectedClubs] = useState({});
  const navigate = useNavigate();
  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);
  const messageTypeRef = useRef(null);
  const studentNameRef = useRef(null);
  const initiatedByRef = useRef(null);
  const sectionRef = useRef(null);
  const classRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    if (orgId && branchId) {
      fetchSubjectGroups(orgId, branchId);
    }
  }, []);

  useEffect(() => {
    const fetchFilteredStudentList = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicSessionId = localStorage.getItem("academicSessionId");
      const selectedClubStudentId = localStorage.getItem(
        "selectedClubStudentId"
      );
      if (orgId && branchId && academicSessionId) {
        setLoadingStudents(true);
        try {
          const url =
            `${ApiUrl.apiurl}FILTER/GetStudentListBasedOnClassAndSectionGroup?` +
            `org_id=${orgId}` +
            `&branch_id=${branchId}` +
            `&academic_year_id=${academicSessionId}` +
            `&class_id=${selectedClass || 0}` +
            `&section_id=${selectedSection || 0}` +
            `&subject_group_id=${selectedClub || 0}` +
            `&student_id=${selectedClubStudentId || 0}`;
          const response = await fetch(url);
          const result = await response.json();
          if (
            response.ok &&
            result.message.toLowerCase() === "success" &&
            Array.isArray(result.data)
          ) {
            setFilteredStudentList(result.data);
            setErrorStudents(null);
          } else {
            setFilteredStudentList([]);
            setErrorStudents("No students found or an error occurred.");
          }
        } catch (error) {
          setFilteredStudentList([]);
        } finally {
          setLoadingStudents(false);
        }
      }
    };
    fetchFilteredStudentList();
  }, [selectedClass, selectedSection, selectedClub]);

  const fetchSubjectGroups = async (orgId, branchId) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}SubjectGroups/GetAllSubjectGroupsList/${orgId}/${branchId}`
      );
      const result = await response.json();
      if (
        response.ok &&
        result.message === "Success" &&
        Array.isArray(result.data) &&
        result.data.length > 0
      ) {
        const firstSubjectId = result.data[0].id;
        setClubId(firstSubjectId);
        console.log("Club ID set to:", firstSubjectId);
      } else {
        console.error("Error fetching subject groups:", result.message);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const fetchClubs = async (classId, sectionId) => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");
    if (orgId && branchId && academicSessionId && classId) {
      try {
        const clubUrl =
          `${ApiUrl.apiurl}CLUBS/GetClubListBasedOnClassAndSection?` +
          `org_id=${orgId}` +
          `&branch_id=${branchId}` +
          `&academic_year_id=${academicSessionId}` +
          `&class_id=${classId}` +
          `&section_id=${sectionId}`;

        const response = await fetch(clubUrl);
        let result = { data: [] };

        if (response.status !== 204) {
          result = await response.json();
        }

        if (
          response.ok &&
          (result.message || "").toLowerCase() === "success" &&
          Array.isArray(result.data)
        ) {
          if (result.data.length > 0) {
            setClubOptions(result.data);
            return;
          }

          if (clubId) {
            const subjectUrl =
              `${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection?` +
              `org_id=${orgId}` +
              `&branch_id=${branchId}` +
              `&academic_year_id=${academicSessionId}` +
              `&subjectGroupId=${clubId}` +
              `&class_id=${classId}` +
              `&section_id=${sectionId}`;

            const subjectResponse = await fetch(subjectUrl);
            if (subjectResponse.status === 204) {
              setClubOptions([]);
              return;
            }

            const subjectResult = await subjectResponse.json();
            if (
              subjectResponse.ok &&
              (subjectResult.message || "").toLowerCase() === "success" &&
              Array.isArray(subjectResult.data)
            ) {
              setClubOptions(subjectResult.data);
              return;
            }
          }

          setClubOptions([]);
        } else {
          setClubOptions([]);
          console.log("No clubs found for the selected class and section.");
        }
      } catch (error) {
        console.error("Error fetching clubs:", error);
      }
    }
  };

  const handleSearchClick = () => {
    setIsSearchClicked(true);
  };

  useEffect(() => {
    const fetchFilteredStudentList = async () => {
      if (!isSearchClicked) return;

      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicSessionId = localStorage.getItem("academicSessionId");
      const selectedClubStudentId = localStorage.getItem(
        "selectedClubStudentId"
      );

      if (orgId && branchId && academicSessionId) {
        setLoadingStudents(true);
        try {
          const url =
            `${ApiUrl.apiurl}FILTER/GetStudentListBasedOnClassAndSectionGroup?` +
            `org_id=${orgId}` +
            `&branch_id=${branchId}` +
            `&academic_year_id=${academicSessionId}` +
            `&class_id=${selectedClass || 0}` +
            `&section_id=${selectedSection || 0}` +
            `&subject_group_id=${selectedClub || 0}` +
            `&student_id=${selectedClubStudentId || 0}`;
          const response = await fetch(url);
          const result = await response.json();

          if (
            response.ok &&
            result.message.toLowerCase() === "success" &&
            Array.isArray(result.data)
          ) {
            setFilteredStudentList(result.data);
            setErrorStudents(null);
          } else {
            setFilteredStudentList([]);
            setErrorStudents("No students found or an error occurred.");
          }
        } catch (error) {
          setFilteredStudentList([]);
        } finally {
          setLoadingStudents(false);
        }
      }
    };

    if (isSearchClicked) {
      fetchFilteredStudentList();
    }

    return () => setIsSearchClicked(false);
  }, [isSearchClicked, selectedClass, selectedSection, selectedClub]);

  const handleClear = () => {
    if (dateFromRef.current) dateFromRef.current.value = "";
    if (dateToRef.current) dateToRef.current.value = "";
    if (messageTypeRef.current) messageTypeRef.current.value = "";
    if (studentNameRef.current) studentNameRef.current.value = "";
    if (initiatedByRef.current) initiatedByRef.current.value = "";
    if (sectionRef.current) sectionRef.current.value = "";
    if (classRef.current) classRef.current.value = "";

    setSelectedClass("");
    setSelectedSection("");
    setSelectedClub("");
    setClubOptions([]);

    setFilteredStudentList([]);
    setSelectedClubs({});

    localStorage.removeItem("clubClass");
    localStorage.removeItem("clubSection");
    localStorage.removeItem("selectedClubStudentId");
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSelectStudent = (student) => {
    const fullName = `${student.studentBasicDetails.first_name} ${student.studentBasicDetails.middle_name} ${student.studentBasicDetails.last_name}`;
    studentNameRef.current.value = fullName;
    handleCloseModal();
  };
  const handleClassChange = (event) => {
    const classId = event.target.value;
    setSelectedClass(classId);
    localStorage.setItem("clubClass", classId);
    setSelectedSection("");
    localStorage.removeItem("clubSection");
    fetchClubs(classId, 0);
  };
  const handleSectionChange = (event) => {
    const sectionId = event.target.value;
    setSelectedSection(sectionId);
    localStorage.setItem("clubSection", sectionId);
    fetchClubs(selectedClass, sectionId || 0);
  };

  const handleGeneralClubChange = (event) => {
    const clubId = event.target.value;
    setSelectedClub(clubId);
  };

  const handleStudentClubChange = (studentId, event) => {
    const clubId = event.target.value;
    setSelectedClubs((prevSelectedClubs) => ({
      ...prevSelectedClubs,
      [studentId]: clubId,
    }));
  };

  const updateClub = async (studentId) => {
    const selectedClubId = selectedClubs[studentId];

    if (!selectedClubId) {
      alert(
        "No club selected for this student. Please select a club before updating."
      );
      return;
    }

    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");

    const payload = {
      clubmasterId: selectedClubId,
      org_id: orgId,
      branch_id: branchId,
      academic_year_id: academicSessionId,
    };

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}CLUBS/updatestudentclub/${studentId}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok && result.message === "Club updated successfully!") {
        alert("Club updated successfully!");

        // Clear this student's dropdown after a successful update
        setSelectedClubs((prev) => {
          const updated = { ...prev };
          delete updated[studentId];
          return updated;
        });
      } else {
        console.error("Error updating club:", result.message);
        alert("Failed to update club: " + result.message);
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("Network error occurred while updating club.");
    }
  };

  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentPageData = filteredStudentList.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredStudentList.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleCheckboxChange = (studentId, checked) => {
    if (checked) {
      setSelectedStudentIds((prev) => [...prev, studentId]);
    } else {
      setSelectedStudentIds((prev) => prev.filter((id) => id !== studentId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = filteredStudentList.map((s) => s.studentId);
      setSelectedStudentIds(allIds);
    } else {
      setSelectedStudentIds([]);
    }
  };

  const updateSelectedClubs = async () => {
    if (selectedStudentIds.length === 0) {
      alert("No students selected for bulk update.");
      return;
    }

    if (!selectedClub) {
      alert("Please select a club for bulk update.");
      return;
    }

    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");

    for (const studentId of selectedStudentIds) {
      const payload = {
        clubmasterId: selectedClub,
        org_id: orgId,
        branch_id: branchId,
        academic_year_id: academicSessionId,
      };

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}CLUBS/updatestudentclub/${studentId}/`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();
        if (!(response.ok && result.message === "Club updated successfully!")) {
          console.error(`Failed to update student ${studentId}:`, result.message);
        }
      } catch (error) {
        console.error("Network error:", error);
      }
    }

    // Clear the dropdown state for every student that was bulk-updated
    setSelectedClubs((prev) => {
      const updated = { ...prev };
      selectedStudentIds.forEach((id) => delete updated[id]);
      return updated;
    });

    alert("Bulk update completed!");
    setSelectedStudentIds([]);
    setSelectedClub("");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT CLUB
              </p>
              <div className="row mb-3 mt-3  mx-0 ">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSearchClick}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    {" "}
                    Clear{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    {" "}
                    Close
                  </button>
                  <button
                    className="btn btn-primary mb-2"
                    style={{ width: "150px" }}
                    onClick={updateSelectedClubs}
                  >
                    Bulk Update
                  </button>
                </div>
              </div>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3  mb-4">
                        <label className="form-label">Student Name</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            ref={studentNameRef}
                            disabled={isInputDisabled}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label className="form-label">Class</label>
                        {classesLoading ? (
                          <p>Loading classes...</p>
                        ) : classesError ? (
                          <p>Error loading classes: {classesError}</p>
                        ) : (
                          <Select
                            options={classes.map((cls) => ({
                              value: cls.id,
                              label: cls.classname,
                            }))}
                            value={
                              selectedClass
                                ? {
                                    value: selectedClass,
                                    label: classes.find(
                                      (c) => c.id === selectedClass
                                    )?.classname,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              handleClassChange({
                                target: { value: option?.value || "" },
                              })
                            }
                            placeholder="Select Class"
                            className="detail"
                          />
                        )}
                      </div>

                      <div className="col-12 col-md-3 mb-0">
                        <label className="form-label">Section</label>
                        {sectionsLoading ? (
                          <p>Loading sections...</p>
                        ) : sectionsError ? (
                          <p>Error loading sections: {sectionsError}</p>
                        ) : (
                          <Select
                            options={sections.map((sec) => ({
                              value: sec.section_id,
                              label: sec.sectionname,
                            }))}
                            value={
                              selectedSection
                                ? {
                                    value: selectedSection,
                                    label: sections.find(
                                      (s) => s.section_id === selectedSection
                                    )?.sectionname,
                                  }
                                : null
                            }
                            onChange={(option) =>
                              handleSectionChange({
                                target: { value: option?.value || "" },
                              })
                            }
                            placeholder="Select Section"
                            className="detail"
                          />
                        )}
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="club" className="form-label">
                          Club
                        </label>
                        <Select
                          options={clubOptions.map((club) => ({
                            value: club.id,
                            label:
                              club.clubdescription ||
                              club.subjectdescription ||
                              club.clubcode ||
                              "N/A",
                          }))}
                          value={
                            selectedClub
                              ? {
                                  value: selectedClub,
                                  label:
                                    clubOptions.find(
                                      (c) => c.id === selectedClub
                                    )?.clubdescription ||
                                    clubOptions.find(
                                      (c) => c.id === selectedClub
                                    )?.subjectdescription ||
                                    "N/A",
                                }
                              : null
                          }
                          onChange={(option) =>
                            handleGeneralClubChange({
                              target: { value: option?.value || "" },
                            })
                          }
                          placeholder="Select Club"
                          className="detail"
                        />
                      </div>

                      <Modal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  {loadingStudents ? (
                    <p>Loading students...</p>
                  ) : errorStudents ? (
                    <p style={{ color: "red" }}>{errorStudents}</p>
                  ) : (
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                handleSelectAll(e.target.checked)
                              }
                              checked={
                                selectedStudentIds.length ===
                                filteredStudentList.length
                              }
                            />
                          </th>
                          <th>Sr.No</th>
                          <th>Student Name</th>
                          <th>Barcode</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>House</th>
                          <th>Club</th>
                          <th>Update</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentPageData.length > 0 ? (
                          currentPageData.map((student, index) => (
                            <tr key={student.studentId}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedStudentIds.includes(
                                    student.studentId
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      student.studentId,
                                      e.target.checked
                                    )
                                  }
                                />
                              </td>
                              <td>{offset + index + 1}</td>
                              <td>{student.studentName}</td>
                              <td>{student.barcode}</td>
                              <td>{student.classname}</td>
                              <td>{student.sectionname}</td>
                              <td>{student.father_name}</td>
                              <td>{student.mother_name}</td>
                              <td>{student.house}</td>
                              <td>
                                <Select
                                  options={clubOptions.map((club) => ({
                                    value: club.id,
                                    label:
                                      club.clubdescription ||
                                      club.subjectdescription ||
                                      club.clubcode ||
                                      "N/A",
                                  }))}
                                  value={
                                    selectedClubs[student.studentId]
                                      ? {
                                          value: selectedClubs[student.studentId],
                                          label:
                                            clubOptions.find(
                                              (c) =>
                                                c.id === selectedClubs[student.studentId]
                                            )?.clubdescription ??
                                            clubOptions.find(
                                              (c) =>
                                                c.id === selectedClubs[student.studentId]
                                            )?.subjectdescription ??
                                            "N/A",
                                        }
                                      : null
                                  }
                                  onChange={(option) =>
                                    handleStudentClubChange(student.studentId, {
                                      target: { value: option?.value || "" },
                                    })
                                  }
                                  placeholder="Select Club"
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      minWidth: "100px",
                                      width: "100%",
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "32px",
                                      fontSize: "14px",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      maxHeight: 150,
                                      overflowY: "auto",
                                    }),
                                    menuList: (provided) => ({
                                      ...provided,
                                      maxHeight: 150,
                                      overflowY: "auto",
                                    }),
                                  }}
                                  menuPlacement="auto"
                                />
                              </td>

                              <td>
                                <button
                                  onClick={() => updateClub(student.studentId)}
                                  style={{
                                    width: "100px",
                                    color: "black",
                                    borderRadius: "4px",
                                  }}
                                >
                                  Update
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" style={{ textAlign: "center" }}>
                              No students available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "pagination justify-content-center mt-3"
                    }
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};
export default AdmAttendanceEntry;
